import React from "react";

const NotFoundPage = () => {
  return (
    <h1 className="text-center font-bold text-lg">
      ERROR 404 - Not Found Page
    </h1>
  );
};

export default NotFoundPage;
